/* eslint-disable camelcase */

import { makeObservable, observable, override, set, toJS } from 'mobx'
import Address from './Address'
import ClientsSynced from './ClientsSynced'
import ClientsAddress from './ClientsAddress'
import Model from './Model'

class Client extends Model {
  @observable id
  @observable address_id
  @observable clients_synced_id = ''
  @observable address = new Address()
  @observable clients_synced = {}
  /**
   *
   * @type {Array<ClientsAddress>}
   */
  @observable clients_addresses = []
  @observable activity_field = ''
  @observable contact_email = ''
  @observable contact_name = ''
  @observable contact_title = ''
  @observable created = ''
  @observable modified = ''
  @observable name = ''
  @observable tel_cellphone = ''
  @observable tel_fax = ''
  @observable tel_office = ''
  @observable tel_other = ''
  @observable type = 'private'
  @observable uuid = ''
  @observable website = ''

  _fieldToSave = [
    'id',
    'address',
    'activity_field',
    'contact_email',
    'contact_name',
    'contact_title',
    'name',
    'tel_cellphone',
    'tel_fax',
    'tel_office',
    'tel_other',
    'type',
    'website'
  ]

  constructor () {
    super()
    makeObservable(this)
  }

  @override
  setData (data) {
    const { address, clients_synced, clients_addresses, ...rest } = data
    set(this, rest)
    if (address) {
      this.address = new Address()
      this.address.setOriginalData(address)
    }
    if (clients_synced) {
      this.clients_synced = new ClientsSynced(clients_synced)
    }

    if (clients_addresses) {
      this.clients_addresses = []
      for (const clientsAddress of clients_addresses) {
        const clientAddress = new ClientsAddress()
        clientAddress.setOriginalData(clientsAddress)
        this.clients_addresses.push(clientAddress)
      }
    }
  }

  toJson () {
    const client = {}
    for (const props of this._fieldToSave) {
      if (this[props] === null) {
        continue
      }
      if (typeof this[props] === 'object') {
        if (typeof this[props].toJson === 'function') {
          client[props] = this[props].toJson()
          continue
        }
      }
      client[props] = toJS(this[props])
    }
    return client
  }
}

export default Client
